import { UnitOfAreaMeasurement } from "./types";

export function mapUnitOfAreaMeasurement(id: number): UnitOfAreaMeasurement {
  if (id === 2) return 'sqft';
  if (id === 3) return 'ha';
  if (id === 4) return 'ac';
  return 'sqm'
}